<template>
    <div class="content">
        <headers :title='titles'></headers>
        <template v-if="loading">
            <!--<div class="wrap"  v-if="testData && testData.length > 0">-->
            <div class="wrap"
                 v-if="true">
                <div class="tip">
                    <div class="tip-img"></div>
                    <p class="tip-p1">请选择一篇课外阅读</p>
                    <p class="tip-p2">进行检查！</p>
                </div>
                <div class="lists">
                    <div class="list"
                         v-for="i in lists"
                         @click="detial(i)">
                        <div>{{i.re_name}}</div>
                    </div>
                </div>
                <div class="bottom_btn"
                     v-if="flagBoon>0">
                    <div class="reward"
                         @click="reward">
                        <p><img src="./img/test_jp.png">奖励和评语</p>
                    </div>
                </div>
            </div>
            <div class="nowork"
                 v-else>
                <div v-cloak>
                    没有作业数据
                </div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';
export default {
    data () {
        return {
            titles: "作业详情",
            lists: [],
            taskId: this.$route.params.taskid, //作业id
            classId: this.$route.params.classid, //班级id
            loading: false,
            flagBoon: this.$route.query.stu_num,
        }
    },
    computed: {},
    methods: {
        back () {
            this.$router.go(-1)
        },
        detial (i) {
            this.$router.push("/chinese/inspect/outread/detial/" + i.unit_class_id + '/' + i.message_id + '/' + i.re_id + '/4')
        },
        reward () {
            this.$router.push("/tea/testreward/51/" + this.taskId + "/" + this.classId)
        }
    },
    created () {
        this.loading = true;
        let type = this.type;
        //this.$router.push("/chinese/inspect/outread/detial")
        this.$http.post(API_URL_TASK_API + '/chinese/check/reading/task/list', {
            "message_id": this.taskId,
            "unit_class_id": this.classId,
        }).then(res => {
            this.loading = true;
            if (res.data.response == 'ok') {
                this.lists = res.data.data;
                //console.log(this.lists)
                /*if(this.lists.length==1){
                    this.$router.push("/chinese/inspect/outread/detial/" + this.lists[0].unit_class_id + '/' + this.lists[0].message_id + '/' + this.lists[0].re_id +
                        '/4')
                }*/
            }
        })
    },
    destroyed () { },
    components: {
        loadingS,
        headers,
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
.content {
    min-height: 100vh;
    background-color: $c-fbg;
    .tip {
        border-top: 1px / $ppr solid transparent;
        text-align: center;
        .tip-img {
            width: 130px / $ppr;
            height: 116px / $ppr;
            margin: 96px / $ppr auto;
            background: url(img/book.png) no-repeat;
            background-size: 100% 100%;
        }
        .tip-p1 {
            font-size: 34px / $ppr;
            font-weight: bold;
            margin: 20px / $ppr auto;
        }
        .tip-p2 {
            font-size: 28px / $ppr;
            color: #999;
        }
        span {
            color: #ff6600;
        }
    }
    .list {
        div {
            width: 440px / $ppr;
            height: 80px / $ppr;
            line-height: 80px / $ppr;
            font-size: 36px / $ppr;
            color: #fff;
            text-align: center;
            margin: 40px / $ppr auto;
            border-radius: 40px / $ppr;
            background-color: #5e89ef;
        }
    }
}

.nowork {
    color: $c-light;
    text-align: center;
    margin-top: 304px / $ppr;
}

.block {
    display: block !important;
}

.bottom_btn {
    width: 100%;
    height: 98px / $ppr;
    margin-top: 25px / $ppr;
    .reward {
        position: fixed;
        bottom: 0;
        left: 0;
        background: #ff6600;
        color: #fff;
        width: 100%;
        p {
            width: 160px / $ppr;
            margin: 0 auto;
            line-height: 98px / $ppr;
            padding-left: 50px / $ppr;
            position: relative;
        }
        img {
            display: block;
            position: absolute;
            width: 40px / $ppr;
            top: 28px / $ppr;
            left: 0;
        }
    }
}
</style>

